// extracted by mini-css-extract-plugin
export default {"wrapper":"AIEventCreateForm_wrapper__unUBx","channelWarning":"AIEventCreateForm_channelWarning__AEC7h"};